import axios, { ApiResponse, ApiRoutes } from "@/api/client";
import { handleApiError } from "@/api/helpers";
import { EventLog } from "@/types";

// right now we only fetch import logs, but audit logs are shared across products

// domain is required.
const getImportLogs = async (pageSize: number): Promise<EventLog[]> =>
  axios
    .get(ApiRoutes.LOGS, {
      params: { domain: "import", page_size: pageSize },
    })
    .then((response: ApiResponse<{ event_logs: EventLog[] | null }>) => response.data.data.event_logs ?? [])
    .catch(handleApiError("Failed to fetch import audit logs."));

const LogService = {
  getImportLogs,
};
export default LogService;
